import _toConsumableArray from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import membershipCurrentImage from "../../assets/images/membership-current.jpg";
import membershipControlImage from "../../assets/images/membership-control.jpg";
import nutritionalHealthProductImage from "../../assets/images/nutritional-health-product-card.jpg";
import vitaminsSupplmentsPromoImage from "../../assets/images/vitamins-supplements-promo.jpg";
export var Tag;
!function (e) {
  e.General = "general", e.NutritionalHealth = "nutritional-health", e.VitaminsAndSupplements = "vitamins-and-supplements", e.Men = "men", e.Women = "women", e.SexualHealth = "sexual-health", e.COVID = "covid", e.None = "";
}(Tag || (Tag = {}));
export var productCategories = [{
  displayName: "Nutritional Health",
  slug: Tag.NutritionalHealth
}, {
  displayName: "Vitamins & Supplements",
  slug: Tag.VitaminsAndSupplements
}, {
  displayName: "General Wellness",
  slug: Tag.General
}, {
  displayName: "Sexual Health",
  slug: Tag.SexualHealth
}, {
  displayName: "Women's Health",
  slug: Tag.Women
}, {
  displayName: "Men's Health",
  slug: Tag.Men
}, {
  displayName: "COVID-19",
  slug: Tag.COVID
}];
export var productLinks = function productLinks(e) {
  return [{
    slug: "food-sensitivity-test",
    label: "Food Sensitivity Test",
    url: e + "/products/food-sensitivity/",
    tags: [Tag.NutritionalHealth]
  }, {
    slug: "food-sensitivity-comprehensive-test",
    label: "Food Sensitivity Comprehensive Test",
    url: e + "/products/food-sensitivity-comprehensive-test/",
    tags: [Tag.NutritionalHealth]
  }, {
    slug: "metabolism-test",
    label: "Metabolism Test",
    url: e + "/products/metabolism/",
    tags: [Tag.NutritionalHealth]
  }, {
    slug: "vitamin-d-and-inflammation-test",
    label: "Vitamin D and Inflammation Test",
    url: e + "/products/vitamin-d-and-inflammation-test/",
    tags: [Tag.NutritionalHealth]
  }, {
    slug: "vitamin-d-test",
    label: "Vitamin D Test",
    url: e + "/products/vitamin-d-test/",
    tags: [Tag.NutritionalHealth]
  }, {
    slug: "thyroid-test",
    label: "Thyroid Test",
    url: e + "/products/thyroid-test/",
    tags: [Tag.General]
  }, {
    slug: "fit-colon-cancer-screening-test",
    label: "FIT Colon Cancer Screening Test",
    url: e + "/products/fit-colon-cancer-screening-test/",
    tags: [Tag.General]
  }, {
    slug: "lyme-disease-test",
    label: "Lyme Disease Test",
    url: e + "/products/lyme-disease-test/",
    tags: [Tag.General]
  }, {
    slug: "indoor-outdoor-allergy-test",
    label: "Indoor & Outdoor Allergy Test",
    url: e + "/products/indoor-outdoor-allergy-test/",
    tags: [Tag.General]
  }, {
    slug: "covid-19-test",
    label: "COVID-19 Test Home Collection Kit DTC",
    url: e + "/products/covid-19-test/",
    tags: [Tag.General]
  }, {
    slug: "cholesterol-and-lipids-test",
    label: "Cholesterol and Lipids Test",
    url: e + "/products/cholesterol-and-lipids-test/",
    tags: [Tag.General]
  }, {
    slug: "heart-health-test",
    label: "Heart Health Test",
    url: e + "/products/heart-health-test/",
    tags: [Tag.General]
  }, {
    slug: "hba1c-test",
    label: "HbA1c Test",
    url: e + "/products/hba1c/",
    tags: [Tag.General]
  }, {
    slug: "sleep-and-stress-panel",
    label: "Sleep and Stress Test",
    url: e + "/products/sleep-and-stress-panel/",
    tags: [Tag.General]
  }, {
    slug: "elements-panel",
    label: "Heavy Metals Test",
    url: e + "/products/elements-panel/",
    tags: [Tag.General]
  }, {
    slug: "testosterone-test",
    label: "Testosterone Test",
    url: e + "/products/testosterone-test/",
    tags: [Tag.Men]
  }, {
    slug: "mens-health-test",
    label: "Men's Health Test",
    url: e + "/products/mens-health-test/",
    tags: [Tag.Men]
  }, {
    slug: "hpv-test-female",
    label: "HPV Test - Female",
    url: e + "/products/hpv-test-female/",
    tags: [Tag.Women]
  }, {
    slug: "womens-health-test",
    label: "Women's Health Test",
    url: e + "/products/womens-health-test/",
    tags: [Tag.Women]
  }, {
    slug: "ovarian-reserve-test",
    label: "Ovarian Reserve Test",
    url: e + "/products/ovarian-reserve-test/",
    tags: [Tag.Women]
  }, {
    slug: "perimenopause-test",
    label: "Perimenopause Test",
    url: e + "/products/perimenopause-test/",
    tags: [Tag.Women]
  }, {
    slug: "postmenopause-test",
    label: "Postmenopause Test",
    url: e + "/products/postmenopause-test/",
    tags: [Tag.Women]
  }, {
    slug: "womens-fertility-test",
    label: "Women's Fertility Test",
    url: e + "/products/womens-fertility-test/",
    tags: [Tag.Women]
  }, {
    slug: "trichomoniasis-test",
    label: "Trichomoniasis Test",
    url: e + "/products/trichomoniasis-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "chlamydia-gonorrhea-test",
    label: "Chlamydia and Gonorrhea Test",
    url: e + "/products/chlamydia-gonorrhea-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "hepatitis-c-test",
    label: "Hepatitis C Test",
    url: e + "/products/hepatitis-c-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "syphilis-test",
    label: "Syphilis Test",
    url: e + "/products/syphilis-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "hiv-test",
    label: "HIV Test",
    url: e + "/products/hiv-test/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "std-test-female",
    label: "STD Test - Female",
    url: e + "/products/std-test-female/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "std-test-male",
    label: "STD Test - Male",
    url: e + "/products/std-test-male/",
    tags: [Tag.SexualHealth]
  }, {
    slug: "individual-covid-19-test",
    label: "COVID-19 Test Home Collection Kit DTC",
    url: e + "/products/covid-19-test/",
    tags: [Tag.COVID]
  }, {
    slug: "covid-bd-veritor-rapid-test",
    label: "BD Veritor At-Home COVID-19 Test",
    url: e + "/products/covid-bd-veritor-rapid-test/",
    tags: [Tag.COVID]
  }, {
    slug: "business-covid-19",
    label: "COVID Testing for Qualifying Organizations",
    url: e + "/business/covid-19",
    tags: [Tag.COVID]
  }, {
    slug: "vitamin-d3-2000-iu",
    label: "Vitamin D3",
    url: e + "/products/vitamin-d3-2000-iu",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  }, {
    slug: "omega-3-fish-oil-1000-mg",
    label: "Omega-3 Fish Oil",
    url: e + "/products/omega-3-fish-oil-1000-mg",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  }, {
    slug: "vitamin-b12-500-mcg",
    label: "Vitamin B12",
    url: e + "/products/vitamin-b12-500-mcg",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  }, {
    slug: "vitamin-b6-50-mg",
    label: "Vitamin B6",
    url: e + "/products/vitamin-b6-50-mg",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  }];
};
export var productCards = function productCards(e, t) {
  return [{
    slug: "control-membership",
    label: "Control –\nProactive Health",
    url: e + "/control-membership/",
    tags: [],
    description: "Choose from 14 different health tests and save 50%+ every month.",
    image: {
      alt: "Control — Proactive Health Membership",
      src: membershipControlImage
    },
    cta: "control" === (null == t ? void 0 : t.type) ? "View Dashboard" : "Become a member",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-link-control-membership"
  }, {
    slug: "current-membership",
    label: "Current –\nSexual Health",
    url: e + "/current-membership/",
    tags: [],
    description: "Choose from 5 different STI tests and save up to 70% every month.",
    image: {
      alt: "Current – Sexual Health Membership",
      src: membershipCurrentImage
    },
    cta: "current" === (null == t ? void 0 : t.type) ? "View Dashboard" : "Become a member",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-link-current-membership"
  }, {
    slug: "nutritional-health",
    label: "",
    url: e + "/products/?category=13",
    tags: [Tag.NutritionalHealth],
    description: "New vitamins and supplements: nourishment for a healthier you.",
    image: {
      alt: "Nutritional Health",
      src: nutritionalHealthProductImage
    },
    cta: "Explore Nutritional Health",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-link-nutritional-health"
  }];
};
export var mainPromo = function mainPromo(e) {
  return {
    headline: "New Vitamins & Supplements",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-promo-vitamins-and-supplements",
    product: {
      slug: "vitamins-and-supplements",
      label: "Clean, simple, and backed by science. Smarter formulas you can trust.",
      url: e + "/products?category=11",
      tags: [],
      image: {
        alt: "Vitamins and Supplements Image",
        src: vitaminsSupplmentsPromoImage
      }
    }
  };
};
export var promoCards = function promoCards(e) {
  return [];
};
export var combinedProducts = function combinedProducts(e) {
  return [].concat(_toConsumableArray(productLinks(e)), _toConsumableArray(productCards(e)));
};